import i18next from 'i18next';
import FetchBackend from 'i18next-fetch-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import type { i18n, InitOptions, Module } from 'i18next';

export const initI18n = (options: InitOptions): Promise<i18n> =>
  new Promise((resolve, reject) => {
    i18next
      .use(FetchBackend)
      .use(LanguageDetector as unknown as Module)
      .init(options, (error) => {
        if (error) {
          reject(error);
        } else {
          resolve(i18next as unknown as i18n);
        }
      });
  });
